/**
 * Blood Bowl Calculator - Probability Calculation Hook
 *
 * Wraps the probability calculation functions for use in React components.
 */

import { useCallback } from "react";
import type { CalculatorState, CalculationResults } from "../types";
import { calculateProbabilities } from "../lib/probability";

export function useProbabilityCalculation() {
  const calculate = useCallback(
    (state: CalculatorState): CalculationResults => {
      // Build groups in the format expected by calculateProbabilities
      const groups = state.actionGroups.map((group) => ({
        id: group.id,
        playerId: group.playerId,
        actions: group.actions.map((action) => ({
          id: action.id,
          type: action.type,
          result: action.result,
          rerollPreference: action.rerollPreference,
        })),
      }));

      return calculateProbabilities(groups, state.players, state.teamRerolls);
    },
    []
  );

  return { calculate };
}
